import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authRegister',
	data () {
		return {
			countryCode: '',
			mobile: '',
			securityCode: '',
			isSubmitting: false
		}
	},
	mounted () {
		setTimeout(() => {
			this.focus()
		}, 10)
	},
	methods: {
		focus () {
			// $('#inputVerifyCode').focus()
		},
		onSubmit (e) {
			this.$validator.validateAll().then((result) => {
				if(result) {
					this.isSubmitting = true
					e.preventDefault()

					const data = {
						mobile: this.mobile,
						security_code: this.securityCode
					}
					
					api.register(data, (response) => {
						this.isSubmitting = false
						this.alertSuccessMessage(response)
					}, (e) => {
						this.isSubmitting = false
						// this.handleErrorMessage(e)
						// console.log(e.status)
						this.alertErrorMessage(e, '#authRegister')
					})
				}
			})
		},
	
		inputOnlyNumber (e) {
			e = (e) ? e : window.event
			var charCode = (e.which) ? e.which : e.keyCode
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				e.preventDefault()
			} else {
				return true
			}
		},
	},
	watch: {
	}
})